// actions/topicActions.js

export const setSelectedChatTopic = (topic) => {
    return {
        type: 'SET_SELECTED_CHAT_TOPIC',
        payload: topic,
    };
};

export const setSelectedForumTopic = (topic) => {
    return {
        type: 'SET_SELECTED_FORUM_TOPIC',
        payload: topic,
    };
};
